module.exports = __webpack_public_path__ + "img/icon-our-marketing-1.33b15178.png";